import React, { useState, useEffect } from 'react';
import { useQueryClient, useQuery, useMutation } from 'react-query';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { CloseIcon } from 'icons';
import { Button } from 'components';
import defaultApp from 'constants';
import BagItem from './item';

import messages from 'messages';

function Bag({ ...props }) {
    const queryClient = useQueryClient();

    const domain = queryClient.getQueryData('restaurant')?.domain || '';
    const restaurantMutation = useMutation('restaurant-mutation');

    const { formatMessage } = props.intl;

    const currency = queryClient.getQueryData('restaurant')?.currency || 'EUR';
    const app = useQuery('app')?.data || defaultApp;
    const bag = useQuery('bag')?.data || [];
    const history = useHistory();
    const limit = process.env.REACT_APP_LIMIT_PER_ORDER;
    const [update, setUpdate] = useState(true);
    const [total, setTotal] = useState(0);
    const [quantity, setQuantity] = useState(0);

    const checkLocation = () => {
        return (
            window.location.pathname === `/${domain}/thank-you` ||
            window.location.pathname === `/${domain}` ||
            window.location.pathname === `/${domain}/`
        );
    };

    const closeBag = () => {
        queryClient.setQueryData('app', (prevData) => ({ ...prevData, toggleBag: false }));
    };

    const getTotal = () => {
        let total = 0;
        let quantity = 0;

        bag.forEach((el) => {
            total = total + parseFloat(el.amount) * el.quantity;
            quantity = quantity + el.quantity;
        });

        setTotal(total);
        setQuantity(quantity);
    };

    const goToSender = () => {
        if (quantity > limit) {
            showNotify('error', formatMessage(messages.genericLimit));

            return;
        }

        history.push(`/${domain}/sender`);
        closeBag();
    };

    const showNotify = (type, text) => {
        queryClient.setQueryData('notify', {
            type,
            text,
            action: 'show',
        });

        hideNotify();
    };

    const hideNotify = () => {
        setTimeout(() => {
            queryClient.setQueryData('notify', (prevData) => ({
                ...prevData,
                action: '',
            }));
        }, 5000);
    };

    useEffect(() => {
        if (update) {
            setUpdate(false);
        } else {
            setUpdate(true);
        }

        getTotal();
    }, [JSON.stringify(bag)]);

    if (checkLocation() || restaurantMutation.isLoading) return '';

    return (
        <div className={`container-bag ${app.toggleBag ? 'active' : ''}`}>
            <div className="header">
                <h4>
                    {formatMessage(messages.genericBag)} ({bag.length})
                </h4>

                <CloseIcon
                    size={11}
                    className="icon"
                    onClick={() => closeBag()}
                    data-test="button-close"
                />
            </div>

            <div className="content">
                {bag.map((el, index) => (
                    <BagItem key={index} item={el} index={index} />
                ))}
            </div>
            <div className="shadow"></div>
            <Button disabled={!bag.length} onClick={() => goToSender()} data-test="button-checkout">
                {formatMessage(messages.genericCheckout)} - {currency} {total}
            </Button>
        </div>
    );
}

export default injectIntl(Bag);
